import React, { Suspense, useEffect } from 'react';
import { reportReloadedLazyContentMount } from '../chunkDiagnostics';
// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const CommittedRoute = ({ component: Component, routeProps }) => {
    useEffect(() => { reportReloadedLazyContentMount(); }, []);
    return <Component {...routeProps} />;
};

const Loadable = (Component) => (props) =>
    (
        <Suspense fallback={<Loader />}>
            <CommittedRoute component={Component} routeProps={props} />
        </Suspense>
    );

export default Loadable;
